import { Button as MuiButton, Theme, styled } from '@material-ui/core';

export const TextVariantButton = styled(MuiButton)<Theme>(({ theme }) => ({
  background: 'none',
  border: 'none',
  borderRadius: 0,
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.bodyMd.fontSize,
  textDecoration: 'none',
  color: theme.palette.grey['900'],
  '&:hover': {
    textDecoration: 'underline',
    background: 'none',
    color: theme.palette.grey['A700'],
  },
  '&:disabled': {
    color: theme.palette.grey['500'],
  },
  '@media print': {
    display: 'none',
  },
}));
